/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DevDateTimeRange
 */
export interface DevDateTimeRange {
    /**
     * 
     * @type {Date}
     * @memberof DevDateTimeRange
     */
    from?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof DevDateTimeRange
     */
    to?: Date | null;
}

/**
 * Check if a given object implements the DevDateTimeRange interface.
 */
export function instanceOfDevDateTimeRange(value: object): value is DevDateTimeRange {
    return true;
}

export function DevDateTimeRangeFromJSON(json: any): DevDateTimeRange {
    return DevDateTimeRangeFromJSONTyped(json, false);
}

export function DevDateTimeRangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DevDateTimeRange {
    if (json == null) {
        return json;
    }
    return {
        
        'from': json['from'] == null ? undefined : (new Date(json['from'])),
        'to': json['to'] == null ? undefined : (new Date(json['to'])),
    };
}

export function DevDateTimeRangeToJSON(json: any): DevDateTimeRange {
    return DevDateTimeRangeToJSONTyped(json, false);
}

export function DevDateTimeRangeToJSONTyped(value?: DevDateTimeRange | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'from': value['from'] == null ? undefined : ((value['from'] as any).toISOString()),
        'to': value['to'] == null ? undefined : ((value['to'] as any).toISOString()),
    };
}

